/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monstertrialperiod7d2Inputs */



/**
* | output |
* | --- |
* | "week" |
*
* @param {Monstertrialperiod7d2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monstertrialperiod7d2 = /** @type {((inputs?: Monstertrialperiod7d2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monstertrialperiod7d2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("week")
	if (locale === "es") return /** @type {LocalizedString} */ ("semana")
	return /** @type {LocalizedString} */ ("неделя")
});
export { monstertrialperiod7d2 as "monsterTrialPeriod7d" }